module.exports = __webpack_public_path__ + "static/media/Logo.5fb208b1.svg";